var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagePrevIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25103 12.5883C8.91628 12.2629 8.91628 11.7345 9.25103 11.4091L13.5358 7.24405C13.8705 6.91865 14.4142 6.91865 14.7489 7.24405C15.0837 7.56944 15.0837 8.09788 14.7489 8.42327L11.0694 12L14.7462 15.5767C15.081 15.9021 15.081 16.4306 14.7462 16.756C14.4115 17.0813 13.8679 17.0813 13.5331 16.756L9.24835 12.5909L9.25103 12.5883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagePrevIco);
export default __webpack_public_path__ + "static/media/Page_prev_ico.ef226838f5b8483cf213888827c45e44.svg";
export { ForwardRef as ReactComponent };